import React from 'react';

const Error404 = () => {
    return (
        <h1> Cette page n'existe pas </h1>
    );
};

export default Error404;